
import { Icon, Style, Fill, Stroke, Circle } from 'ol/style.js';

export var blackStroke = new Stroke({
  color: "#000000",
  width: 1
});

export var normMarkerStyle = new Style({
  image: new Circle({
      fill: new Fill({
          color: "#ff6c10"
      }),
      stroke: blackStroke,
      radius: 6
  }),
  zIndex: 100
});
export var TOStartMarkerStyle = new Style({
  image: new Circle({
      fill: new Fill({
          color: "#00ff00"
      }),
      stroke: blackStroke,
      radius: 6
  }),
  zIndex: 120
});
export var TOEndMarkerStyle = new Style({
  image: new Circle({
      fill: new Fill({
          color: "#ff0000"
      }),
      stroke: blackStroke,
      radius: 6
  }),
  zIndex: 120
});
export var hoverMarkerStyle = new Style({
  image: new Circle({
      fill: new Fill({
          color: "#00baf2"
      }),
      stroke: blackStroke,
      radius: 6
  }),
  zIndex: 110
});
export var lineStyle = new Style({
  stroke: new Stroke({
      color: '#ff6c10',
      width: 4
  }),
  zIndex: 90
});

export var TOLineStyle = new Style({
  stroke: new Stroke({
      color: '#ffff00',
      width: 4.2
  }),
  zIndex: 90
});

export function getHoverPopupHtml(data) {
  var name = data.name;
  var address = data.address;

  var html = `
      <div style="min-width: 150px;">
          <div><strong>${name}</strong></div>
  `;
  address.forEach(function(component){
      html += `
          <div>${component}</div>
      `;
  });
  html += `
      </div>
  `;
  return html;
}